import { get } from 'lodash';
import { createSelector } from 'reselect';

import { makeOptionsDataWithEmpty } from 'Common/FormHelper';

const root = (state) => get(state, 'NutritionStandardsReportState');

export const getNutritionStandardsLoading = (state) =>
  get(root(state), 'getNutritionStandards.loading');
export const getNutritionStandardsResult = (state) =>
  get(root(state), 'getNutritionStandards.data');
export const getNutritionStandardsErrors = (state) =>
  get(root(state), 'getNutritionStandards.errors');

export const nutritionStandardOptions = createSelector(
  [getNutritionStandardsResult],
  (nutritionStandards) => {
    //Temporarily filtering out SFSP standards for the Nutrional Standards report
    const filteredNutritionStandards = nutritionStandards.filter((standard) => {
      return !standard.Description.endsWith('SFSP');
    });
    return makeOptionsDataWithEmpty(filteredNutritionStandards);
  }
);



// WEBPACK FOOTER //
// ./src/pages/nutritionstandardsreport/state/selectors.js